import {createContext} from 'react'

const NotifContext = createContext()

export default NotifContext